import "core-js/modules/es6.regexp.match";
import "core-js/modules/es6.regexp.constructor";
import _regenerator from "/www/wwwroot/build/dev/THIS-gfast-front-pc/node_modules/@babel/runtime-corejs2/helpers/esm/regenerator.js";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/www/wwwroot/build/dev/THIS-gfast-front-pc/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
import { Message } from 'element-ui';
import request from '@/utils/request';
var tTimer;
var flag;
var timeout = null;
var common = {
  install: function install(Vue) {
    Vue.prototype.$common = this;
  },
  //js文件大小转化值加单位
  renderSize: function renderSize(value, type) {
    if (null == value || value == '') {
      return "0 Bytes";
    }
    var unitArr = new Array("Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB");
    var index = 0;
    var srcsize = parseFloat(value);
    //后台的单位是1000 不是1024
    index = Math.floor(Math.log(srcsize) / Math.log(1000));
    var size = srcsize / Math.pow(1000, index);
    size = size.toFixed(2); //保留的小数位数
    if (type == 'unit') {
      //返回单位
      return unitArr[index];
    } else {
      //返回值加单位
      return size;
    }
  },
  //过滤 通过键得到值
  filterUser: function filterUser(list, id) {
    // console.log(list,id)
    var user_nickname = null;
    if (list) {
      list.forEach(function (v) {
        var key = v.id || v.key;
        if (key == id) {
          user_nickname = v.user_nickname || v.name || v.value || v.train_content;
        }
      });
    }
    return user_nickname;
  },
  //上传文件的键 (写死的根据上传配置该)
  uploadkeyArr: [{
    id: 1,
    name: '上传头像',
    key: 'upload_config_personal_avatar'
  }, {
    id: 2,
    name: '站点logo',
    key: 'upload_config_website_logo'
  }, {
    id: 3,
    name: '培训管理',
    key: 'upload_config_train_manage'
  }, {
    id: 4,
    name: '电子签名',
    key: 'upload_config_e_signature'
  }, {
    id: 5,
    name: 'GCP证书2',
    key: 'upload_config_gcp_certificate'
  }, {
    id: 6,
    name: '简历',
    key: 'upload_config_resume'
  }],
  // 上传文件方法，type=功能配置key
  upload: function upload(type, e) {
    if (!type) {
      return Message.error('上传参数错误');
    }
    return new Promise(function (resolve, reject) {
      try {
        var fd = new FormData();
        fd.append('file', e.file || e);
        fd.append('config_type_key', type);
        request({
          url: '/system/upload/upFile',
          method: 'POST',
          data: fd
        }).then(function (res) {
          resolve(res);
        }).catch(function (err) {
          Message.error(err.msg);
          reject(err);
        });
      } catch (error) {
        reject();
      }
    });
  },
  // 获取字典配置
  getDicts: function getDicts(dictType) {
    return new Promise(/*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(resolve, reject) {
        var res, code, data, msg, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              _context.n = 1;
              return request({
                url: '/system/config/dict/data/GetDictData',
                method: 'get',
                params: {
                  dictType: dictType
                }
              });
            case 1:
              res = _context.v;
              code = res.code, data = res.data, msg = res.msg;
              if (code === 0) {
                resolve(data);
              } else {
                reject(msg);
              }
              _context.n = 3;
              break;
            case 2:
              _context.p = 2;
              _t = _context.v;
              reject(_t);
            case 3:
              return _context.a(2);
          }
        }, _callee, null, [[0, 2]]);
      }));
      return function (_x, _x2) {
        return _ref.apply(this, arguments);
      };
    }());
  },
  // 根据key获取value
  getVariable: function getVariable(name) {
    var string = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : location.href;
    var r = new RegExp('(\\?|#|&)' + name + '=([^&#]*)(&|#|$)');
    var m = string.match(r);
    return decodeURIComponent(!m ? '' : m[2]);
  },
  // 数组转对象
  arrayToObj: function arrayToObj(arr) {
    return arr.reduce(function (obj, item) {
      return obj[item.key] = item.value, obj;
    }, {});
  },
  // 节流原理：在一定时间内，只能触发一次
  throttle: function throttle(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    if (immediate) {
      if (!flag) {
        flag = true;
        // 如果是立即执行，则在wait毫秒内开始时执行
        typeof func === 'function' && func();
        tTimer = setTimeout(function () {
          flag = false;
        }, wait);
      }
    } else {
      if (!flag) {
        flag = true;
        // 如果是非立即执行，则在wait毫秒内的结束处执行
        tTimer = setTimeout(function () {
          flag = false;
          typeof func === 'function' && func();
        }, wait);
      }
    }
  },
  // 防抖原理：一定时间内，只有最后一次操作，再过wait毫秒后才执行函数
  debounce: function debounce(func) {
    var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
    var immediate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (timeout !== null) clearTimeout(timeout);
    if (immediate) {
      var callNow = !timeout;
      timeout = setTimeout(function () {
        timeout = null;
      }, wait);
      if (callNow) typeof func === 'function' && func();
    } else {
      timeout = setTimeout(function () {
        typeof func === 'function' && func();
      }, wait);
    }
  }
};
export default common;